import { render, staticRenderFns } from "./bulk.vue?vue&type=template&id=0cfad960&scoped=true"
import script from "./bulk.vue?vue&type=script&lang=js"
export * from "./bulk.vue?vue&type=script&lang=js"
import style0 from "./bulk.vue?vue&type=style&index=0&id=0cfad960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfad960",
  null
  
)

export default component.exports